import axios from 'axios';
import store from '@/store';
import {
  SET_LOADING,
  SET_ALERT,
  SET_ERROR,
  SET_ALERT_CONTEXT,
} from '@/store/mutation_types';

axios.interceptors.request.use((config) => {
  store.commit(SET_LOADING, true);
  // eslint-disable-next-line no-param-reassign
  config.url = `${process.env.VUE_APP_ROOT_ENDPOINT}${config.url}`;
  // eslint-disable-next-line no-param-reassign
  config.headers = {
    ...config.headers,
    'x-header-token': store.getters.token,
  };
  return config;
}, (error) => {
  store.commit(SET_LOADING, false);
  store.commit(SET_ALERT, true);
  store.commit(SET_ERROR, true);
  store.commit(SET_ALERT_CONTEXT, error.response);
  return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
  store.commit(SET_LOADING, false);
  return response;
}, (error) => {
  store.commit(SET_LOADING, false);
  store.commit(SET_ALERT, true);
  store.commit(SET_ERROR, true);
  store.commit(SET_ALERT_CONTEXT, error.response.data);
  return Promise.reject(error);
});

export default axios;
